import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import { fontWeightClassName, fontWeights } from './font-weights';
import { getTypographyClassNames } from './helpers';
import { HeadingProps, TypographyProps, TypographyVariants } from './types';

export const Heading1 = <T extends keyof TypographyVariants>({
  weight = fontWeights.normal,
  colorClassName = 'text-text-dark',
  variant,
  variantSize,
  className,
  children,
  'data-testid': dataTestId,
}: PropsWithChildren<HeadingProps & TypographyProps<T>>) => {
  const typographyClasses = getTypographyClassNames({ variant, variantSize });

  const classes = classNames(
    'font-primary',
    { 'text-5xl leading-54 -tracking-0036': !typographyClasses, [typographyClasses]: !!typographyClasses },
    fontWeightClassName(weight),
    colorClassName,
    className,
  );

  return (
    <h1 data-testid={dataTestId} className={classes}>
      {children}
    </h1>
  );
};
